/** ref.
 * https://github.com/module-federation/core/issues/2672#issuecomment-2192671980
 * https://github.com/module-federation/module-federation-examples/blob/master/runtime-plugins/offline-remote/app1/offline-remote.js
 */
export default function () {
  const getErrorMessage = (id, error) => {
    if (error) {
      return `${id} is offline due to error: ${error}`;
    }

    return `${id} is offline`;
  };

  return {
    name: 'offline-remote-plugin',
    async errorLoadRemote({ id, error, from, origin }) {
      // Make debugging easier: show cause during builds/SSR.
      console.error(id, 'offline', { from, origin, error: error ? String(error) : null });
      const MyError = (await import('pages/_error')).default;

      if (from === 'build') {
        return () => ({
          __esModule: true,
          default: MyError,
          getServerSideProps: () => {
            return {
              props: {
                status_message: getErrorMessage(id, error),
              },
            };
          },
        });
      }

      return {
        default: MyError,
        getServerSideProps: async () => {
          return {
            props: {
              status_message: getErrorMessage(id, error),
            },
          };
        },
      };
    },
  };
}
